import ReactAudioPlayer from 'react-audio-player';
import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBackward, faForward ,faRotateLeft,faRotateRight} from '@fortawesome/free-solid-svg-icons';
import styles from "@/styles/pages/audioBookPage.module.scss";
interface Props {
    audiobookId?: string;
    audiobookDictionary?: any;
    setSelectedTrack?: any;
    selectedCurrentTime?: any;

    trackId: string;

}
const getLastPlayed = () => {
    const lastPlayed = localStorage.getItem('lastPlayed');
    return lastPlayed ? JSON.parse(lastPlayed) : null;
};
let playerRef:any;

const AudioPlayer = ({ audiobookId, trackId, audiobookDictionary,setSelectedTrack,selectedCurrentTime }:Props) => {
    // debugger;

    const [currentTime, setCurrentTime] = useState(0);
    // const lastPlayed = getLastPlayed();
    // debugger;
    // if(lastPlayed&&lastPlayed.trackId &&  ( new Date().getTime()-  lastPlayed.timeMs ) / 1000 > 10 ){
    //  //   setSelectedTrack(lastPlayed.trackId);
    //
    // }
    // const [currentTrackId, setCurrentTrackId] = useState('מבוא'); // Set the initial current track
    // if(currentTrackId!==trackId){
    //     trackId=currentTrackId;
    // }
    // Function to save progress to localStorage
    const saveProgress = (audiobookId:string, trackId:string, currentTime:string) => {
        const progressData = {
            audiobookId,
            trackId,
            currentTime, timeMs:new Date().getTime()
        };
        localStorage.setItem('lastPlayed', JSON.stringify(progressData));
    };

    // Function to get the last played progress from localStorage

    useEffect(() => {
        const lastPlayed = getLastPlayed();
        // debugger;
        // let playerRef:any;

        // const {trackId}=lastPlayed;

        if (lastPlayed && lastPlayed.audiobookId === audiobookId && lastPlayed.trackId === trackId) {

            playerRef.audioEl.current.currentTime = lastPlayed.currentTime;
            // setCurrentTime(lastPlayed.currentTime);
        }

        const interval = setInterval(() => {
            // debugger;

            if (playerRef && playerRef.audioEl &&audiobookId && trackId ) {
                saveProgress(audiobookId, trackId, playerRef.audioEl.current.currentTime);
            }
        }, 5000); // Update every 10 seconds

        return () => {
            clearInterval(interval);
        };
    }, [audiobookId,playerRef, trackId]);


    const handleBackward = () => {
        // debugger;
        if (playerRef && playerRef.audioEl) {
            const newTime = playerRef.audioEl.current.currentTime - 15;
            playerRef.audioEl.current.currentTime = newTime >= 0 ? newTime : 0;
        }
    };

    const handleForward = () => {
        if (playerRef && playerRef.audioEl) {
            const newTime = playerRef.audioEl.current.currentTime + 15;
            playerRef.audioEl.current.currentTime = newTime;
        }
    };

    return (
        <div  >
            <center>



            </center>

            <br></br>
            <center className={` ${styles.playerStyle}` }>
                <button onClick={handleForward}>
                    <FontAwesomeIcon icon={faRotateRight} />
                </button>
                <center>


                </center>
                <ReactAudioPlayer
                    controlsList="nodownload"
                    ref={(element) => {
                        playerRef = element;
                    }}
                    autoPlay // Auto-play the next track

                    src={audiobookDictionary[trackId]}
                    controls
                    listenInterval={1000}
                    onListen={() => {
                        if (playerRef && playerRef.audioEl) {
                            setCurrentTime(playerRef.audioEl.current.currentTime);
                        }
                    }}
                    onEnded={() => {
                        // debugger;
                        // Check if there's a next track in the dictionary
                        const trackIds = Object.keys(audiobookDictionary);
                        const currentIndex = trackIds.indexOf(trackId);

                        if (currentIndex < trackIds.length - 1) {
                            const nextTrackId = trackIds[currentIndex + 1];
                            // Set the next track as the current track
                            setSelectedTrack(nextTrackId);
                        }
                    }}

                />

                <button onClick={handleBackward}>
                    <FontAwesomeIcon icon={faRotateLeft} />
                </button>
            </center>


            {/*<div >*/}



            {/*    <div>Current Time: {Math.floor(currentTime)}</div>*/}
            {/*</div>*/}

        </div>
    );
};

export default AudioPlayer;
